import { fromJSON, NoteRecord } from "common/records/Note";
import { RootActions, RootState } from "common/reducers";
import { receive, reset } from "common/reducers/Utils";
import { IdsManagementActions } from "common/reducers/idsManagement.actions";
import { reducer as idsManagementReducer } from "common/reducers/idsManagement.reducer";
import { NoteActions, RECEIVE_NOTE, RECEIVE_NOTES, REMOVE_NOTE, RESET_NOTE } from "common/reducers/note.actions";
import { Nullable } from "common/types";
import { Map, Record } from "immutable";

export const NoteStateRecord = Record({
  byId: Map<number, NoteRecord>(),
  lastSavedById: Map<number, NoteRecord>(),
  currentNoteId: null as Nullable<number>,
});

export const initialState = NoteStateRecord();
export type NoteState = typeof initialState;

const model = "notes";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.getIn([model])) {
    state = state.setIn([model], initialState);
  }
  switch (action.type) {
    case RECEIVE_NOTE:
      const noteRecord = fromJSON(action.payload);

      return receive(state, model, noteRecord);

    case RECEIVE_NOTES: {
      action.payload.notes.forEach((note) => {
        state = reducer(state, NoteActions.receiveNote(note));
      });
      return state;
    }

    case RESET_NOTE: {
      const { noteId } = action.payload;
      return reset(state, model, noteId) as RootState;
    }

    case REMOVE_NOTE:
      state = idsManagementReducer(state, IdsManagementActions.removeId(action.payload.noteId, "notes"));
      return state.deleteIn(["notes", "byId", action.payload.noteId]);

    default:
      return state;
  }
};
